export const getRegionDefaultFilterOptions = () => {
  return {
    year: new Date().getFullYear().toString(),
    month: [],
    region: [],
    portOfCall: [],
    ship: [],
  }
}
